import { React, useState, memo, useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { apiError, loginUserSuccessful, logoutUser, logoutUserSuccess } from '../store/actions';
import { API_URL_GET_USER_DETAIL } from '../common/constants';
import { connect } from 'react-redux';
import store from '../store';
import UrlUtils from '../services/utils/UrlUtils';
import { ROLE_ANALYST, ROLE_ANALYST_ADMIN, ROLE_EMPLOYEE, ROLE_THIRD_PARTY } from '../components/constants';
import axios from 'axios';
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';

const BeforeEachRoute = (props) => {
	const urlUtils = new UrlUtils();
	const orgId = urlUtils.getOrganizationId();

	const [completed, setCompleted] = useState(false);

	const {
		modules	:	{
            isLoading               :   moduleSettingIsLoading,
			active	                :	selectedModuleName,
			list	                :   avModulesList,
            featuresLoadingStatus   :   currentModuleFeaturesLoadingStatus
		},
		user,
		token
	} = props;

	const routeModules = props.routeModules || [];

    const routeFeatures = props.routeFeatures || [];

	const handleFetchAuthUser = async () => {
		try {
			const response = await axios.post(
				API_URL_GET_USER_DETAIL,
				{ organizationId: orgId },
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200) {
				loginUserSuccessful({
					...response.data.data,
				});
				return response.data.data;
			}
		} 
		catch (err) {}

		return false;
	};

	const validateRouteModules = () => {
		if (Array.isArray(routeModules) && routeModules.length > 0) {
			if (!routeModules.includes(selectedModuleName)) {
				const urlSegments = window.location.pathname.split('/');

				if (urlSegments.includes('third-party')) {
					if (!window.location.pathname.includes('/third-party/home')) {
						props.history.push(`/third-party/home`);
					}
					return false;
				} else if (urlSegments.includes('employee') || urlSegments.includes('admin')) {
					if (!window.location.pathname.includes('/admin/start')) {
						props.history.push(`/admin/start`);
					}
					return false;
				}
			}
			else{
				const path = props.history.location.pathname;
				const selectedModuleSettings = (avModulesList.find((module) => module.name === selectedModuleName))?.settings;

				if(
					(path.includes('/voice-report') 			&& !selectedModuleSettings?.isVoice) ||
					(path.includes('/arrange-meeting') 			&& !selectedModuleSettings?.isMeeting) || 
					(path.includes('/report-confidentially')	&& !selectedModuleSettings?.isConfidentially) ||
					(path.includes('/report-anonymously') 		&& !selectedModuleSettings?.isAnonymously) ||
					(path.includes('/e-learning') 				&& !selectedModuleSettings?.isElearning)
				){
					props.history.push(`/fatal-error`);
					return false;
				}
			}
		}

		return true;
	};

	const validateAuthProtectedRoutes = async () => {
		let currentUser = user;

        const pathname = window.location.pathname;
        const params = new URLSearchParams(window.location.search);
        let moduleToAppend = selectedModuleName;

        if (params.has('module')) {
            moduleToAppend = params.get('module');
            params.delete('module');
        }

        const searchParams = params.toString();

        const redirectUrl = `${pathname}${searchParams ? '?' + searchParams : ''}--module=${moduleToAppend}`;

        const mainSigninUrl = `/signin${!pathname.includes('/signin') ? '?redirectUrl=' + redirectUrl : ''}`;
        const thirdpartySigninUrl = `/third-party/signin${!pathname.includes('/third-party/signin') ? '?redirectUrl=' + redirectUrl : ''}`;

		if (props.isAuthProtected) {
			if(!token){
                if(props.type === 'third-party'){
                    props.history.push(thirdpartySigninUrl); 
                }
                else{
                    props.history.push(mainSigninUrl);
                }
				return false;
			}

			if(!user){
				currentUser = await handleFetchAuthUser();

				if(!currentUser){
                    if(props.type === 'third-party'){
                        props.history.push(thirdpartySigninUrl); 
                    }
                    else{
                        props.history.push(mainSigninUrl);
                    }
					return false;
				}
			}

			switch (props.type) {
				case 'employee': {
					if(!currentUser?.roles?.includes(ROLE_EMPLOYEE)){
						store.dispatch(logoutUser());
						props.history.push(mainSigninUrl);
						return false;
					}
					break;
				}
				case 'admin': {
					if (!currentUser?.roles?.includes(ROLE_ANALYST_ADMIN) && !currentUser?.roles?.includes(ROLE_ANALYST)) {
						store.dispatch(logoutUser());
						props.history.push(mainSigninUrl);
						return false;
					}
					break;
				}
				case 'third-party': {
					if (currentUser && !currentUser?.roles?.includes(ROLE_THIRD_PARTY)) {
						store.dispatch(logoutUser());
						props.history.push(thirdpartySigninUrl);
						return false;
					}
					break;
				}
				default: {
					store.dispatch(logoutUser());
					props.history.push(mainSigninUrl);
					return false;
				}
			}
		} 

		if (props.type === 'third-party' && token && Array.isArray(currentUser?.roles) && !currentUser.roles?.includes(ROLE_THIRD_PARTY)){
			store.dispatch(logoutUser());
			props.history.push(thirdpartySigninUrl);
			return false;
		}

		return true;
	}

    const validateRouteFeatures = () => {
        if(routeFeatures.length > 0){
            const notEnabledList =  routeFeatures.filter((feature) => !isFeatureEnabledForActiveModule(feature))

            if(notEnabledList.length > 0){
                /**
                 * currenlty becaouse we dont have a design i return true and not redirect the user 
                 * to the error page
                 * 
                 * do some thing here later and change the return value true to false
                 */
                return true;
            }
        }

        return true;
    }

	const handleInit = async () => {
		if(validateAuthProtectedRoutes() && validateRouteModules() && validateRouteFeatures()){
			setCompleted(true);
		}
	};

	useEffect(() => {
        if(!moduleSettingIsLoading && currentModuleFeaturesLoadingStatus === 'loaded'){
            handleInit();
        }
	}, [
        moduleSettingIsLoading, 
        selectedModuleName, 
        user, 
        token, 
        currentModuleFeaturesLoadingStatus,
    ]);

	return (
		<props.layout authProtected={ props.isAuthProtected }>
			{!completed || !props.workspaceLayout.isPreloader || (
                !props.ignoreModuleLoadingComponent && (moduleSettingIsLoading || currentModuleFeaturesLoadingStatus === 'loading')
            ) ? (
				<div className='card-loading-container'>
					<Spinner className='chat-messages-spinner-loading' color='info' />
				</div>
			) : (
				<props.component {...props.componentProps} />
			)}
		</props.layout>
	);
};

const mapStateToProps = (state) => {
	return {
		token 				:	state.Login.token,
		user				: 	state.Login.user,
		workspaceLayout		:	state.Layout,
		modules				:	state.Modules
	};
};

const mapDispachToProps = (dispach) => {
	return {
		logoutUserSuccess	: () => dispach(logoutUserSuccess()),
		loginUserSuccessful	: (user) => dispach(loginUserSuccessful(user)),
		apiError			: (error) => dispach(apiError(error)),
	};
};

export default withRouter(
	connect(mapStateToProps, mapDispachToProps)(
		memo(BeforeEachRoute)
	)
);
